.couponPaper {
	max-width: unset;
	min-width: 80% !important;
	height: 200px;
	margin: 0px !important;
	margin-left: 10px !important;
	margin-top: -5px !important;
	padding: 10px !important;
}

.confirmButton {
	margin-right: 15px !important;
	margin-top: 5px !important;
	margin-bottom: 5px !important;
}

.cancelButton {
	border-radius: 50% !important;
	background-color: var(--light-gray) !important;
}

.marginTop {
	margin-top: 1px !important;
}

@media (max-width: 540px) {
	.couponPaper {
		margin: 0 !important;
	}
}
